import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function NoDataPlaceholder() {
  return (
    <div className="alert bg-purple-gradient text-center">
      <div>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          size="4x"
          className="text-purple"
        />
      </div>
      <h3>No data to show</h3>
    </div>
  );
}
